/**
 * Log Item Tokens
 */

import { bg, text, accent, corners, space, border } from "../semantic";

export const logItem = {
  minHeight: "44px",
  paddingX: space.insetMd,
  paddingY: space.insetSm,
  gap: space.insetSm,
  radius: corners.card,
  border: `0.5px solid ${border.subtle}`,
  bg: bg.surface,
  bgHover: bg.surfaceHover,
  bgSelected: accent.secondaryMuted,
  time: { width: "52px", fontSize: "11px", color: text.muted },
  dot: { size: "8px" },
  level: { error: accent.danger, warn: accent.warning, info: accent.info, debug: text.muted },
  message: { color: text.primary, fontSize: "13px" },
  details: { marginTop: space.insetSm, marginLeft: "68px", fontSize: "11px", color: text.muted },
} as const;
